<template>
  <template v-for="n in count" :key="n">
    <div class="col-lg-4 col-md-6 col-12">
      <div class="listing-item skeleton-card">
        <div class="listing-img skeleton"></div>
        <div class="listing-content">
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-text short"></div>
          <div class="skeleton skeleton-btn"></div>
        </div>
      </div>
    </div>
  </template>
</template>

<script setup>
const props = defineProps({
  count: {
    type: Number,
    default: 6
  }
})
</script>

<style scoped>
.skeleton {
  background: #eee;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-card {
  padding: 8px;
}

.listing-img.skeleton {
  height: 220px;
}

.skeleton-title {
  height: 20px;
  margin: 10px 0;
}

.skeleton-text {
  height: 14px;
  margin: 6px 0;
}

.skeleton-text.short {
  width: 60%;
}

.skeleton-btn {
  height: 36px;
  margin-top: 10px;
}

@keyframes pulse {
  0% { background-color: #eee; }
  50% { background-color: #ddd; }
  100% { background-color: #eee; }
}
</style>
